import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { TmAccount, TmAddress } from '@/tscapi/model/account';
import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

interface PayloadType {
    address: TmAddress;
    id?: number;
    type: string;
}

//  create/add an address

export const useAddress = () => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    const queryClient = useQueryClient();
    return {
        ...useMutation({
            mutationFn: async (payload: TmAddress) => {
                const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
                if (
                    !(
                        cookie.UserAccessToken != undefined &&
                        cookie.UserAccessToken.Token.length > 0 &&
                        cookie.UserAccessToken.Edp > 0
                    )
                ) {
                    throw new Error('UserToken expired');
                }

                // is there ever a scenario where there isnt an accesstoken?
                return http.post(`${base}${lang}/accounts/${userAccessTokenEdp}/shippingaddresses`, payload);
            },
            onSuccess: async (response, variables, context) => {
                // update address / account data
                queryClient.setQueryData(
                    ['account', cookie.UserAccessToken?.Edp, cookie.Language],
                    response.data as TmAccount,
                );
            },
            onError: (error, variables, context) => {
                console.log('error');
            },
        }),
    };
};

//  remove address
// used in remove card modal
//
export const useRemoveAddress = () => {
    const queryClient = useQueryClient();
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    return {
        ...useMutation({
            mutationFn: (Id: number) => {
                const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
                if (
                    !(
                        cookie.UserAccessToken != undefined &&
                        cookie.UserAccessToken.Token.length > 0 &&
                        cookie.UserAccessToken.Edp > 0
                    )
                ) {
                    throw new Error('UserToken expired');
                }
                return http.delete(`${base}${lang}/accounts/${userAccessTokenEdp}/shippingaddresses/${Id}`);
            },
            onSuccess: (response, variables, context) => {
                // update detail view directly
                queryClient.setQueryData(
                    ['account', cookie.UserAccessToken?.Edp, cookie.Language],
                    response.data as TmAccount,
                );
            },
            onError: (error, variables, context) => {
                console.log(`${context} ${error}`);
            },
        }),
    };
};

//  update address
//
//
export const useUpdateAddress = () => {
    const queryClient = useQueryClient();
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    return {
        ...useMutation({
            mutationFn: (payload: PayloadType) => {
                const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
                if (
                    !(
                        cookie.UserAccessToken != undefined &&
                        cookie.UserAccessToken.Token.length > 0 &&
                        cookie.UserAccessToken.Edp > 0
                    )
                ) {
                    throw new Error('UserToken expired');
                }
                if (payload.type == 'billing') {
                    //billing
                    return http
                        .put(`${base}${lang}/accounts/${userAccessTokenEdp}/billingaddress`, payload.address)
                        .then(() => {
                            return http.post(`${base}${lang}/accounts/${userAccessTokenEdp}/defaultshippingaddress`);
                        });
                } else {
                    //shipping
                    return http.put(
                        `${base}${lang}/accounts/${userAccessTokenEdp}/shippingaddresses/${payload.id}`,
                        payload.address,
                    );
                }
            },
            onSuccess: (response, variables, context) => {
                // removed-  chained to mutation instead of onsuccess here
                // const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
                // if (variables.type == 'billing') {
                //     console.log('billing setting as default shipping');
                //     http.post(`${base}${lang}/accounts/${userAccessTokenEdp}/defaultshippingaddress`);
                // }
                // update detail view directly
                queryClient.setQueryData(
                    ['account', cookie.UserAccessToken?.Edp, cookie.Language],
                    response.data as TmAccount,
                );
            },
            onError: (error, variables, context) => {
                console.log(`${context} ${error}`);
            },
        }),
    };
};
